import { makeStyles } from '@material-ui/core';

export const useNotReceivedStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    marginTop: 20,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
}));
